import { useSelector, useDispatch } from 'react-redux';
import {
  logout,
  clearError,
  refreshUser,
} from '../store/slices/authSlice';
import { UserDetails } from '../utils/utils';

// Helper function to generate mock JWT token in browser
const generateMockToken = (email) => {
  const header = btoa(JSON.stringify({ alg: 'HS256', typ: 'JWT' }));
  const payload = btoa(
    JSON.stringify({
      email,
      iat: Math.floor(Date.now() / 1000),
      exp: Math.floor(Date.now() / 1000) + 24 * 60 * 60, // 24 hours
    })
  );
  const signature =
    Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

  return `${header}.${payload}.${signature}`;
};

export const useAuth = () => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);

  // const setSession = (accessToken) => {
  //   if (accessToken) {
  //     localStorage.setItem('accessToken', accessToken);
  //   } else {
  //     localStorage.removeItem('accessToken');
  //   }
  // };

  // // LOCAL LOGIN - Using UserDetails array validation
  // const login = async (credentials) => {
  //   try {
  //     dispatch(loginStart());

  //     // Find user in UserDetails array
  //     // const user = UserDetails.find(
  //     //   (val) =>
  //     //     val.email === credentials.email.toLowerCase() && val.password === credentials.password
  //     // );

  //   const user = axiosInstance.post(endpoints.auth.login, credentials);


  //     if (!user) {
  //       dispatch(loginFailure('Invalid email or password'));
  //       return { success: false, error: 'Invalid email or password' };
  //     }

  //     // Generate mock token
  //     const mockAccessToken = generateMockToken(credentials.email);
  //     setSession(mockAccessToken);

  //     // Prepare user data
  //     const userData = {
  //       id: user.id || 1,
  //       email: user.email,
  //       firstName: user.firstName || 'User',
  //       lastName: user.lastName || '',
  //       displayName: user.displayName || user.email,
  //       role: user.role || 'user',
  //       isActive: user.isActive !== false,
  //       accessToken: mockAccessToken,
  //     };

  //     // Store in localStorage
  //     localStorage.setItem('user', JSON.stringify(userData));

  //     // Dispatch complete login
  //     dispatch(loginComplete(userData));

  //     return { success: true, data: userData };
  //   } catch (error) {
  //     const errorMessage = error?.message || 'Login failed';
  //     dispatch(loginFailure(errorMessage));
  //     return { success: false, error: errorMessage };
  //   }
  // };

  // // REGISTER
  // const register = async (userData) => {
  //   try {
  //     dispatch(loginStart());

  //     const mockAccessToken = generateMockToken(userData.email);
  //     setSession(mockAccessToken);

  //     const newUser = {
  //       id: Date.now(),
  //       email: userData.email,
  //       firstName: userData.firstName || '',
  //       lastName: userData.lastName || '',
  //       displayName: `${userData.firstName} ${userData.lastName}`.trim(),
  //       role: 'user',
  //       isActive: true,
  //       accessToken: mockAccessToken,
  //     };

  //     localStorage.setItem('accessToken', mockAccessToken);
  //     localStorage.setItem('user', JSON.stringify(newUser));

  //     dispatch(loginComplete(newUser));

  //     return { success: true, data: newUser };
  //   } catch (error) {
  //     const errorMessage = error?.message || 'Registration failed';
  //     dispatch(loginFailure(errorMessage));
  //     return { success: false, error: errorMessage };
  //   }
  // };

  // // LOGOUT
  // const signOut = () => {
  //   setSession(null);
  //   localStorage.removeItem('user');
  //   dispatch(logout());
  // };

  // // GET CURRENT USER
  // const getRefreshUser = async () => {
  //   try {
  //     const userStr = localStorage.getItem('user');
  //     if (userStr) {
  //       const user = JSON.parse(userStr);
  //       dispatch(setUser(user));
  //       return user;
  //     }
  //     return null;
  //   } catch (error) {
  //     console.error('Failed to refresh user:', error);
  //     return null;
  //   }
  // };

  // // REFRESH USER
  // const refreshUser = async (userData) => {
  //   try {
  //     localStorage.setItem('user', JSON.stringify(userData));
  //     dispatch(setUser(userData));
  //     return { success: true };
  //   } catch (error) {
  //     console.error('Failed to update user:', error);
  //     return { success: false };
  //   }
  // };

  return {
    ...auth,
    // login,
    // register,
    // signOut,
    // getRefreshUser,
    // refreshUser,
    authMethod: 'jwt',
    logout: () => dispatch(logout()),
    clearError: () => dispatch(clearError()),
    refreshUser: () => dispatch(refreshUser()),
  };
};
